module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Weather/Night-fog-7d3beb4c2da84d3ca1e68b96c50d043f.svg";